import React from "react";
import Accordion from "../Accordion";
import ProfileGallery from "./ProfileGallery";
import InsCompanyCard from "./InsCompanyCard";
import NoData from "../NoData";
import {withTranslate} from "react-redux-multilingual";
import {setHospitalProfileSkeleton} from "../../skeleton";

const HospitalAbout = ({hospital, activeTab, language, numOfIncCompanies, aboutHospitalIsLoading,translate, toggleShowMore}) => {
    const incCompanies = hospital && hospital.profile.insurance_companies && hospital.profile.insurance_companies.length ? hospital.profile.insurance_companies.slice(0, numOfIncCompanies).map((company, index) => {
            return (
                <span className="tags" key={index}>
                      <InsCompanyCard company={company}/>
                   </span>
            )
        }
    ) : (<NoData image="insurance-company"/>);
    return (
         !aboutHospitalIsLoading
            ?
            <div className="row" hidden={activeTab === false}>
                {hospital && hospital.profile.insurance_companies && hospital.profile.insurance_companies.length ?
                    <div className="row full-width">
                        <div className="col-md-12">
                            <Accordion box="insurance_companies">
                                {incCompanies}
                                <p className=" text-center cursor-pointer bolder dark-blue "
                                   hidden={hospital.profile.insurance_companies.length < numOfIncCompanies || hospital.profile.insurance_companies.length === 5}
                                   onClick={(e) => toggleShowMore(e, 5, "numOfIncCompanies", hospital.profile.insurance_companies.length)}>
                                    {numOfIncCompanies === 5 ?
                                        "+ "
                                        + (hospital.profile.insurance_companies.length - numOfIncCompanies)
                                        + ' '
                                        + translate('show_more') :
                                        translate('show_less')} </p>
                            </Accordion>
                        </div>
                    </div> : null}
                {hospital && hospital.profile.bio !== "No Data To Show" ?
                    <div className="row full-width">
                        <div className="col-md-12">
                            <Accordion box="biography">
                                {hospital.profile.bio}
                            </Accordion>
                        </div>
                    </div> : null}
                {hospital && hospital.profile.gallery && hospital.profile.gallery.length ?
                    <div className="row full-width">
                        <div className="col-md-12">
                            <Accordion box="clinic_gallery">
                                <ProfileGallery language={language}
                                                imagesList={hospital.profile.gallery}/>
                            </Accordion>
                        </div>
                    </div> : null}
            </div>
            :   <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {setHospitalProfileSkeleton(3)}
                    </div>
                </div>
            </div>
    )
}
export default withTranslate(HospitalAbout)